<template>
	<div class="tab-body">
		<el-row class="autoFlex" :gutter="10">
			<el-col :span="8">
				<el-card class="leftCard">
					<div slot="header" class="clearfix">
						<!-- 选择产品的选择列表框 -->
						<el-select style="display: inline-block;" size="small" v-model="productId" clearable
							placeholder="请选择产品" @change="changeProd($event)" @clear="clearProd()">
							<el-option v-for="item in productList" :key="item.id" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
						<span>&nbsp;~&nbsp;产品待办列表&nbsp;&nbsp;</span>
						<el-button type="info" size="mini" @click="treeClick()">返回</el-button>
					</div>

					<el-tree v-loading="treeLoading" ref="productTree" :data="productBacklogList"
						:default-expand-all="treeExpand" @node-click="treeClick"></el-tree>
					 
	                   
				</el-card>
			</el-col>
			<el-col :span="16">
				<el-card class="rightCard">
					<div slot="header" class="clearfix"
						style="display: flex; align-items: center; justify-content: flex-start;">
						<p>{{ rightTitle }}</p>
					 <el-button size="mini"  @click="exportExcel" type="warning">点击导出待办列表清单</el-button>
						 
					</div>
					<div class="operator" v-if="productId">
						<el-button type="primary" size="mini" v-has-permission-code-and="'002000100005'"
							icon="el-icon-plus" @click="toSave()">添加</el-button>
					</div>
					<div class="dataTable autoFlex">
						<el-table :data="productBacklogTable" stripe border height="400">
							<el-table-column width="50" label="序号">
								<template slot-scope="scope">
									{{ scope.$index + 1 }}
								</template>
							</el-table-column>
							<el-table-column prop="label" label="待办名称"></el-table-column>
							<el-table-column width="110" prop="manDay" label="人日(天)" :editable="false"
								sortable></el-table-column>
							<el-table-column label="操作" width="300" fixed="right" ignored
								:editable="false">
								<template slot-scope="scope">
									<div class="dataTable-operator">
										<el-button v-has-permission-code-and="'002000100000'"
											size="mini" icon="el-icon-search" v-if="scope.row.id"
											@click="toDetail(scope.$index, scope.row)">详情
										</el-button>
										<el-button v-has-permission-code-and="'002000100005'"
											size="mini" icon="el-icon-edit" v-if="scope.row.id"
											@click="toUpdate(scope.$index, scope.row)">编辑
										</el-button>
										<el-button v-has-permission-code-and="'002000100005'"
											size="mini" type="danger" icon="el-icon-delete"
											v-if="scope.row.id"
											@click="remove(scope.$index, scope.row)">删除
										</el-button>
									</div>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</el-card>
			</el-col>
		</el-row>
		<edit ref="edit"></edit>
	</div>
</template>
<script>
import edit from './edit.vue';
import tree from '@/components/tree/tree.vue';

import pblAPI from '@/api/product/productBacklog/productBacklog.js';
import productApi from '@/api/product/product/product.js';
import constant from '@/util/constant.js';
import caches from "util/caches.js";
import qlhTable from '@/components/qlhTable/qlhTable.vue';
import qlhTableColumn from '@/components/qlhTable/qlhTableColumn.vue';
export default {
	name: 'product',
	components: {
		tree,
		edit,
		qlhTable,
		qlhTableColumn
	},
	data() {
		return {
			treeLoading: false,
			treeExpand: true,
			downUrl: "",
			productBacklogList: [],

			productId: '',    //当前产品的id
			currentProduct: {},    //当前产品
			productList: [],

			currentNode: {},
			productBacklogTable: [],

			tableLoading: true,
			editParameter: {},
			rightTitle: "顶级待办",

			content: "",
			exportLoading: false,
			excelProp: {
				excelName: '产品信息',
				sheetname: '产品信息'
			},
			allDay: ""
		};
	},
	methods: {

		//获取数据
		list() {

			//1. 取得缓存中选择的产品对象,如果没有,则不查询
			this.productId = this.$caches.pid.get();

			if (this.productList.length == 0) {

				this.productList = this.$caches.products.get();

				if (!this.productList) {

					//拿到所有的产品,并且赋予默认值
					productApi.list4Select({}, response => {
						this.productList = response.data;

						this.$caches.products.set(this.productList);

						if (this.productList && this.productList.length == 0) {
							this.productId = "";
						}

						this.productListForEach()

					})
				} else {

					this.productListForEach()

				}

				//this.downUrl = constant.serverUrl + '/downloadExcel/productBacklog/downloadExcel?productId=' + this.productId

			}

		}, productListForEach() {

			this.treeLoading = true;
			//3. 查询对应产品的所有待办列表信息,呈现
			//有缓存,根据产品id查询出对应的所有产品待办列表
			pblAPI.list({ productId: this.productId }, response => {

				this.productBacklogList = response.data;

				this.productBacklogTable = this.productBacklogList 

				this.productList.forEach(item => {
					if (item.id === this.productId) {
						this.currentProduct = item

						//累加
						this.allDay = 0

						this.productBacklogList.forEach((itm, idx) => {
							this.allDay += itm.manDay * 1
						})

						//设置产品的默认值
						this.rightTitle = "顶级待办  (" + this.allDay + "/" + this.currentProduct.allManDay + "人日)"

						return;
					}
				});


				this.treeLoading = false;
			})
		},



		//获取数据
		reloadData(parameter) {
			this.treeLoading = true;
			//3. 查询对应产品的所有待办列表信息,呈现
			//有缓存,根据产品id查询出对应的所有产品待办列表
			pblAPI.list({ productId: this.productId }, response => {
				this.productBacklogList = response.data;

				console.log("this.productBacklogList", this.productBacklogList)
				this.treeLoading = false;
				if (parameter) {  //需要刷新
					console.log("需要刷新", parameter)
					console.log("this.indexindexindex", parameter.index)
					if (parameter.index) {
						//修改
						this.$set(this.productBacklogTable, parameter.index - 1, parameter);
					} else {    //添加
						parameter.label = parameter.name
						this.productBacklogTable.push(parameter)
						this.$forceUpdate();
					}
				}
			})



		},
		//导出清单
		exportExcel() {
			//从本地存储中拿到产品id

			if (!this.productId) {
				this.$message.error('未选择产品，不可导出！')
				return;
			}
			let fileName 
			//取中文名字
			if(this.productList && this.productList.length>0){
			    this.productList.forEach( (itm)=>{
				if(itm.id ==this.productId){
					fileName = itm.name
					return;
				} 
			    } )
			}
 
			 //取得会话标识
			let tokenVal = caches.token.get();
			// //发送下载请求
			  fileName = fileName+"_pbl"+(new Date().getTime())+".xlsx"
			pblAPI.downloadExcel( { productId: this.productId } , fileName,   { token: tokenVal });

		},
		//选择的产品发生改变时调用的方法
		changeProd(id) {

			//如果是清空当前选择的产品，则直接返回
			if (!id) {
				return;
			}




			//1. 先将id存储到本地存储中,从而下一次来的时候可以直接查询当前产品的产品待办列表
			this.$caches.pid.set(id);


			this.productId = id
			this.downUrl = constant.serverUrl + '/product/productBacklog/downloadExcel?productId=' + id
			//2. 发起查询,查询出对应产品的所有待办列表
			pblAPI.list({ productId: id }, response => {
				this.productBacklogList = response.data;

				this.productList.forEach(item => {
					if (item.id === id) {
						//设置产品的默认值
						this.currentProduct = item

						//累加
						this.allDay = 0

						this.productBacklogList.forEach((itm, idx) => {
							this.allDay += itm.manDay * 1
						})

						//设置产品的默认值
						this.rightTitle = "顶级待办  (" + this.allDay + "/" + this.currentProduct.allManDay + "人日)"
						return;
					}
				})


				this.treeLoading = false;
			})


		},
		//清空选择的产品时调动的方法
		clearProd() {

			//将数据清空，并且需要把本地存储的productId进行删除
			this.productBacklogList = [{}];
			this.$caches.pid.remove();
			this.treeLoading = false;

		},
		//点击节点
		treeClick(data) {

			if (data) {
				this.currentNode = data;
				if (this.currentNode.children) {
					this.rightTitle = (this.currentNode.level + 1) + "级待办 - " + this.currentNode.label
				} else {
					this.rightTitle = (this.currentNode.level + 1) + "级," + this.currentNode.label
				}
				this.productBacklogTable = data.children
			} else {
				this.currentNode = {};

				this.productBacklogTable = this.productBacklogList
				//累加
				this.allDay = 0

				this.productBacklogList.forEach((itm, idx) => {
					this.allDay += itm.manDay * 1
				})

				//设置产品的默认值
				this.rightTitle = "顶级待办  (" + this.allDay + "/" + this.currentProduct.allManDay + "人日)"


			}
		},
		//去添加
		toSave() {
			if (this.currentNode.level == 3) {
				this.$utils.msg.warning("待办请不要超过3级");
			} else {

				let parameter = {
					pid: this.currentNode.id ? this.currentNode.id : '0',
					nxtId: this.productBacklogTable && this.productBacklogTable.length > 0 ? this.productBacklogTable[this.productBacklogTable.length - 1].priority + 1 : 1
				};
				console.log(this.currentNode)
				this.$refs.edit.open(parameter, '添加' + (this.currentNode.label ?  this.currentNode.label:"")+" 下的子节点");
			}
		},
		//去编辑
		toUpdate(index, row) {
			//顶级节点才可修改所属产品
			row.index = index + 1

			this.$refs.edit.open(row, '编辑');
		},
		//去详情
		toDetail(index, row) {
			let detailParameter = {
				id: row.id
			};
			this.$refs.edit.open(detailParameter, '详情', true);
		},
		//删除
		remove(index, row) {
			let parameter = {
				ids: row.id
			}
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				pblAPI.remove(
					parameter,
					response => {
						this.$utils.msg.success(response.msg);
						//删除后更新根节点数据
						this.productListForEach();
						//右边回显
						this.productBacklogTable.splice(index, 1)
						

					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
	},

	mounted() {
		this.list();
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
</style>
